// Curated clinical abbreviation / lay-term expansions for ICD-10 search.
// Keys are normalized (lowercase, accent-folded, single spaces). Values are
// 1-2 phrases that literally appear in ICD-10-CM description wording, so the
// expanded query matches the index's partialMatching search. English values by
// design (the index descriptions are English); Spanish KEYS are included since
// Colombia is the primary Spanish-language market. Starter set pending
// clinician review - additions are data-only, no engine change.
export const ICD10_SYNONYMS = {
  // Cardiovascular
  htn: ["hypertension"],
  hbp: ["hypertension"],
  "high blood pressure": ["hypertension"],
  "blood pressure": ["hypertension"],
  afib: ["atrial fibrillation"],
  "a-fib": ["atrial fibrillation"],
  af: ["atrial fibrillation"],
  chf: ["heart failure"],
  hf: ["heart failure"],
  cad: ["atherosclerotic heart disease"],
  mi: ["myocardial infarction"],
  "heart attack": ["myocardial infarction"],
  nstemi: ["non-st elevation"],
  stemi: ["st elevation"],
  pvd: ["peripheral vascular disease"],
  pad: ["atherosclerosis of native arteries"],
  dvt: ["deep vein thrombosis"],
  svt: ["supraventricular tachycardia"],
  cva: ["cerebral infarction"],
  stroke: ["cerebral infarction"],
  tia: ["transient cerebral ischemic attack"],
  "mini stroke": ["transient cerebral ischemic attack"],

  // Endocrine / metabolic
  dm: ["diabetes mellitus"],
  dm2: ["type 2 diabetes"],
  t2dm: ["type 2 diabetes"],
  dm1: ["type 1 diabetes"],
  t1dm: ["type 1 diabetes"],
  "high sugar": ["hyperglycemia"],
  hld: ["hyperlipidemia"],
  "high cholesterol": ["hypercholesterolemia"],
  hypothyroid: ["hypothyroidism"],
  "low thyroid": ["hypothyroidism"],
  "overactive thyroid": ["hyperthyroidism"],
  "low vitamin d": ["vitamin d deficiency"],
  "low b12": ["b12 deficiency"],
  "low sodium": ["hyponatremia"],
  "low potassium": ["hypokalemia"],
  "high potassium": ["hyperkalemia"],
  "morbid obesity": ["morbid (severe) obesity"],

  // Pulmonary
  copd: ["chronic obstructive pulmonary"],
  sob: ["shortness of breath"],
  osa: ["obstructive sleep apnea"],
  "sleep apnea": ["sleep apnea"],
  uri: ["upper respiratory infection"],
  pna: ["pneumonia"],
  pe: ["pulmonary embolism"],
  "blood clot lung": ["pulmonary embolism"],

  // GI
  gerd: ["gastro-esophageal reflux"],
  "acid reflux": ["gastro-esophageal reflux"],
  heartburn: ["gastro-esophageal reflux"],
  ibs: ["irritable bowel syndrome"],
  gib: ["gastrointestinal hemorrhage"],
  "gi bleed": ["gastrointestinal hemorrhage"],
  nafld: ["fatty liver"],
  "fatty liver": ["fatty"],

  // Renal / GU
  ckd: ["chronic kidney disease"],
  aki: ["acute kidney failure"],
  arf: ["acute kidney failure"],
  esrd: ["end stage renal disease"],
  uti: ["urinary tract infection"],
  "bladder infection": ["urinary tract infection"],
  bph: ["hyperplasia of prostate"],
  "enlarged prostate": ["hyperplasia of prostate"],
  "kidney stone": ["calculus of kidney"],

  // Musculoskeletal / Neuro
  oa: ["osteoarthritis"],
  djd: ["osteoarthritis"],
  ra: ["rheumatoid arthritis"],
  lbp: ["low back pain"],
  "back pain": ["back pain"],
  "neck pain": ["cervicalgia"],
  sciatica: ["sciatica"],
  "pinched nerve": ["radiculopathy"],
  carpal: ["carpal tunnel"],
  migraine: ["migraine"],
  ha: ["headache"],
  sz: ["epilepsy"],
  seizure: ["epilepsy"],
  neuropathy: ["polyneuropathy"],

  // Psych
  mdd: ["major depressive disorder"],
  gad: ["generalized anxiety disorder"],
  adhd: ["attention-deficit hyperactivity"],
  ptsd: ["post-traumatic stress disorder"],
  ocd: ["obsessive-compulsive disorder"],
  etoh: ["alcohol"],
  sud: ["substance use"],

  // Heme / ID / misc
  "low iron": ["iron deficiency anemia"],
  "low blood": ["anemia"],
  hx: ["history of"],
  fx: ["fracture"],
  "broken bone": ["fracture"],
  "yeast infection": ["candidiasis"],
  cellulitis: ["cellulitis"],
  "pressure sore": ["pressure ulcer"],
  bedsore: ["pressure ulcer"],
  "leg ulcer": ["ulcer of lower limb"],
  "swollen legs": ["edema"],

  // Spanish lay terms (accent-folded keys; the engine folds queries the same way)
  hipertension: ["hypertension"],
  "presion alta": ["hypertension"],
  "tension alta": ["hypertension"],
  "azucar alta": ["hyperglycemia"],
  colesterol: ["hypercholesterolemia"],
  "insuficiencia cardiaca": ["heart failure"],
  infarto: ["myocardial infarction"],
  epoc: ["chronic obstructive pulmonary"],
  asma: ["asthma"],
  neumonia: ["pneumonia"],
  pulmonia: ["pneumonia"],
  gripe: ["influenza"],
  reflujo: ["gastro-esophageal reflux"],
  "higado graso": ["fatty"],
  "infeccion urinaria": ["urinary tract infection"],
  "calculo renal": ["calculus of kidney"],
  "dolor de espalda": ["back pain"],
  "dolor de cabeza": ["headache"],
  migrana: ["migraine"],
  ansiedad: ["anxiety"],
  depresion: ["depressive"],
  obesidad: ["obesity"],
  anemia: ["anemia"],
  artritis: ["arthritis"],
  tiroides: ["thyroid"],
  embarazo: ["pregnancy"],
  convulsiones: ["epilepsy"],
  "derrame cerebral": ["cerebral infarction"],
};
